import httpClient from './httpClient'

const apiStoreInfo = val => httpClient.post('/inc/storesv2.php', val),
    apiSaveStore = val => httpClient.post('/inc/storesv2.php', val)

export { apiStoreInfo, apiSaveStore }
